export default {
  storageNamespace: 'player',
  volume: 0.7,
}
